<template>
  <div class="link-button-container">
    <LinkButton
      v-if="showReOpenCommentButton"
      :text="t('contextual_comments_re_open_comment')"
      :is-bold="true"
      data-external="conversation-card-re-open-comment-button"
      @click="$emit('re-open')"
    />
    <LinkButton
      v-else-if="showViewEntireThreadButton"
      :text="t('contextual_comments_view_entire_thread')"
      icon="chevron-down"
      data-external="conversation-card-view-entire-thread-button"
    />
    <FriedButton
      v-else-if="showGoToCommentButton"
      data-external="conversation-card-go-to-comment-button"
      class="go-to-comment-button"
      @click="$emit('go-to')"
    >
      {{ t('cc_go_to_comment') }}
    </FriedButton>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import LinkButton from '../../components/LinkButton.vue';

export default defineComponent({
  components: {
    LinkButton,
  },
  props: {
    showReOpenCommentButton: {
      type: Boolean,
      required: true,
    },
    showViewEntireThreadButton: {
      type: Boolean,
      required: true,
    },
    showGoToCommentButton: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['go-to', 're-open'],
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>
<style lang="scss" scoped>
.link-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: $spacing-100;

  .go-to-comment-button {
    width: 100%;
  }
}
</style>
